export const CLINICAL_LEAD_COLUMNS = {
  name: {
    key: 'name',
    label: 'Name',
    isSortable: false,
  },
  clinicalLeadOrgan: {
    key: 'clinicalLeadOrgan',
    label: 'Clinical Lead Organ',
    isSortable: false,
  },
  phone: {
    key: 'phone',
    label: 'Phone Number',
    isSortable: false,
  },
  reservationCondition: {
    key: 'reservationCondition',
    label: 'Reservation Condition',
    isSortable: false,
  },
  action: {
    key: 'action',
    label: '',
    isSortable: false,
  },
};

export const getClinicalLeadColumns = () => [
  CLINICAL_LEAD_COLUMNS.name,
  CLINICAL_LEAD_COLUMNS.clinicalLeadOrgan,
  CLINICAL_LEAD_COLUMNS.phone,
  CLINICAL_LEAD_COLUMNS.reservationCondition,
  CLINICAL_LEAD_COLUMNS.action,
];
